unit Unit3;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls,
  WEBLib.ExtCtrls, WEBLib.CDS, DB, WEBLib.DB,
  WEBLib.Buttons, Math;

type
  TForm3 = class(TForm)
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebLabel10: TLabel;
    WebEdit5: TEdit;
    WebLabel5: TLabel;
    WebEdit6: TEdit;
    WebLabel6: TLabel;
    WebEdit7: TEdit;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebLabel9: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebEdit12: TEdit;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebEdit18: TEdit;
    WebLabel30: TLabel;
    WebLabel31: TLabel;
    WebEdit19: TEdit;
    WebLabel32: TLabel;
    WebEdit20: TEdit;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebEdit21: TEdit;
    WebLabel35: TLabel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    WebImageControl1: TImageControl;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form3: TForm3;

implementation


uses uFrmMain;

procedure TForm3.WebFormCreate(Sender: TObject);
var   ROB, DOD, ORI, FAK1, FAK2, WSK, ENE   : Real;
      KAT                                   : String;
begin

//Lokalizacja  			              -> txtSampleText
//Uzysk				                    -> WebEdit1
//Zyżycie energii		  	          -> WebEdit2
//Koszt energii			              -> WebEdit3
//Produkcja energii		            -> WebEdit4
//Wartość inwestycji		          -> WebEdit5
//Typ modułu			                -> WebEdit12
//Typ inwertera			              -> WebEdit13
//Typ instalacji			            -> WebEdit14
//Rodzaj dachu			              -> WebEdit15
//Orientacja instalacji		        -> WebEdit8
//Sugerowana wielkość instslacji	-> WebEdit7
//Cena konstrukcji		            -> WebEdit6
//Cena modułu			                -> WebEdit18
//Cena inwertera			            -> WebEdit19
//Położenie			                  -> WebEdit9
//Lczba modułów			              -> WebEdit10
//Moc modułów			                -> WebEdit16
//Ilość inwerterów	  	          -> WebEdit11
//Moc inwertra			              -> WebEdit17
//Kąt nachylenia instalacji	      -> WebEdit20

KAT:=FrmMain.WebEdit20.Text;

WebEdit1.Text:=FrmMain.WebEdit7.Text;
WebEdit2.Text:=FrmMain.WebEdit14.Text;
WebEdit3.Text:=FrmMain.WebEdit12.Text;
WebEdit4.Text:=FrmMain.WebEdit13.Text;
WebEdit5.Text:=FrmMain.WebEdit15.Text;
WebEdit6.Text:=FrmMain.WebEdit8.Text;
WebEdit7.Text:=FrmMain.WebEdit9.Text;
WebEdit8.Text:=FrmMain.WebEdit16.Text;
WebEdit9.Text:=FrmMain.WebEdit17.Text;
WebEdit10.Text:=FrmMain.WebEdit10.Text;
WebEdit11.Text:=FrmMain.WebEdit11.Text;
WebEdit12.Text:=FloattoStr(StrtoFloat(FrmMain.WebEdit10.Text)*StrtoFloat(FrmMain.WebEdit16.Text)/1000);
if StrtoFloat(WebEdit12.Text)<50 then begin ROB:=350; DOD:=5500; end;
if StrtoFloat(WebEdit12.Text)<30 then begin ROB:=400; DOD:=5000; end;
if StrtoFloat(WebEdit12.Text)<20 then begin ROB:=500; DOD:=4500; end;
if StrtoFloat(WebEdit12.Text)<10 then begin ROB:=600; DOD:=4000; end;
if StrtoFloat(WebEdit12.Text)<5 then begin ROB:=650; DOD:=3500; end;

ENE:=StrtoFloat(FrmMain.WebEdit2.Text);
if ENE>StrtoFloat(FrmMain.WebEdit4.Text) then ENE:=StrtoFloat(FrmMain.WebEdit4.Text);

if FrmMain.WebEdit14.Text='Płaski' then WebImageControl1.URL:='img\'+'plaski.jpg';
if FrmMain.WebEdit14.Text='Skośny' then  WebImageControl1.URL:='img\'+'skosny.jpg';
if FrmMain.WebEdit14.Text='Grunt' then WebImageControl1.URL:='img\'+'grunt.jpg';

case KAT of
'40': FAK1:=0.99;
'35': FAK1:=1;
'30': FAK1:=0.99;
'25': FAK1:=0.92;
'20': FAK1:=0.85;
'15': FAK1:=0.78;
'10': FAK1:=0.67;
end;

WebEdit13.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit1.Text)*StrtoFloat(FrmMain.WebEdit6.Text)*1.1));
WebEdit14.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit10.Text)*StrtoFloat(FrmMain.WebEdit18.Text)));
WebEdit15.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit11.Text)*StrtoFloat(FrmMain.WebEdit19.Text)));
WebEdit16.Text:=FloattoStr(DOD);
WebEdit17.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit12.Text)*ROB));
WebEdit18.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit13.Text)+StrtoFloat(WebEdit14.Text)+StrtoFloat(WebEdit15.Text)+StrtoFloat(WebEdit16.Text)+StrtoFloat(WebEdit17.Text)));
WebEdit20.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit18.Text)*0.08));
WebEdit21.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit20.Text)+StrtoFloat(WebEdit18.Text)));
FrmMain.WebEdit5.Text:=WebEdit21.Text;
//ShowMessage(' WE21 '+WebEdit21.Text+' FWE4 '+FrmMain.WebEdit4.Text+' WE21 '+WebEdit21.Text+' WE21 '+WebEdit21.Text+
WebEdit19.Text:=FloattoStr(SimpleRoundTo (StrtoFloat(WebEdit21.Text)/(ENE*StrtoFloat(FrmMain.WebEdit21.Text))/FAK1));

end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);
  WebEdit21 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  WebEdit21.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 539;
    WebLabel1.Top := 86;
    WebLabel1.Width := 85;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Wielko'#347#263' instalacji';
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 100;
    WebLabel2.Width := 72;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Typ konstrukcji';
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 8;
    WebLabel3.Top := 142;
    WebLabel3.Width := 141;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Typ modu'#322'u fotowoltaicznego';
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 186;
    WebLabel4.Width := 71;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Typ inwerttrea';
    WebLabel10.SetParentComponent(Self);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 8;
    WebLabel10.Top := 77;
    WebLabel10.Width := 205;
    WebLabel10.Height := 16;
    WebLabel10.Caption := 'Dane instalacji fotowoltaiccznej';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clMenuHighlight;
    WebLabel10.Font.Height := 16;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.ParentFont := False;
    WebLabel10.Transparent := False;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 97;
    WebLabel5.Top := 100;
    WebLabel5.Width := 77;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Rodzaj instalacji';
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 212;
    WebLabel6.Top := 100;
    WebLabel6.Width := 94;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Orientacja instalacji';
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 317;
    WebLabel7.Top := 100;
    WebLabel7.Width := 96;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Orientacja modu'#322#243'w';
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 595;
    WebLabel8.Top := 119;
    WebLabel8.Width := 21;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'kWp';
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 256;
    WebLabel9.Top := 142;
    WebLabel9.Width := 57;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Moc modu'#322'u';
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 208;
    WebLabel11.Top := 186;
    WebLabel11.Width := 68;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'Moc inwertera';
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 312;
    WebLabel12.Top := 163;
    WebLabel12.Width := 16;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'Wp';
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 264;
    WebLabel13.Top := 207;
    WebLabel13.Width := 16;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Wp';
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 339;
    WebLabel14.Top := 142;
    WebLabel14.Width := 68;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Ilo'#347#263' modu'#322#243'w';
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 295;
    WebLabel15.Top := 186;
    WebLabel15.Width := 75;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'lo'#347#263' inwerter'#243'w';
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 395;
    WebLabel16.Top := 163;
    WebLabel16.Width := 18;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'szt.';
    WebLabel17.SetParentComponent(Self);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 351;
    WebLabel17.Top := 207;
    WebLabel17.Width := 18;
    WebLabel17.Height := 13;
    WebLabel17.Caption := 'szt.';
    WebLabel18.SetParentComponent(Self);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 495;
    WebLabel18.Top := 119;
    WebLabel18.Width := 21;
    WebLabel18.Height := 13;
    WebLabel18.Caption := 'kWp';
    WebLabel19.SetParentComponent(Self);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 429;
    WebLabel19.Top := 100;
    WebLabel19.Width := 85;
    WebLabel19.Height := 13;
    WebLabel19.Caption := 'Wielko'#347#263' instalacji';
    WebLabel20.SetParentComponent(Self);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 429;
    WebLabel20.Top := 141;
    WebLabel20.Width := 80;
    WebLabel20.Height := 13;
    WebLabel20.Caption := 'Koszt konstrukcji';
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 429;
    WebLabel21.Top := 183;
    WebLabel21.Width := 72;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Koszt modu'#322#243'w';
    WebLabel22.SetParentComponent(Self);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 429;
    WebLabel22.Top := 227;
    WebLabel22.Width := 79;
    WebLabel22.Height := 13;
    WebLabel22.Caption := 'Koszt inweter'#243'w';
    WebLabel23.SetParentComponent(Self);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 429;
    WebLabel23.Top := 269;
    WebLabel23.Width := 88;
    WebLabel23.Height := 13;
    WebLabel23.Caption := 'Koszty dodatkowe';
    WebLabel24.SetParentComponent(Self);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 429;
    WebLabel24.Top := 310;
    WebLabel24.Width := 70;
    WebLabel24.Height := 13;
    WebLabel24.Caption := 'Koszt monta'#380'u';
    WebLabel25.SetParentComponent(Self);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 495;
    WebLabel25.Top := 162;
    WebLabel25.Width := 18;
    WebLabel25.Height := 13;
    WebLabel25.Caption := 'PLN';
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 495;
    WebLabel26.Top := 204;
    WebLabel26.Width := 18;
    WebLabel26.Height := 13;
    WebLabel26.Caption := 'PLN';
    WebLabel27.SetParentComponent(Self);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 495;
    WebLabel27.Top := 248;
    WebLabel27.Width := 18;
    WebLabel27.Height := 13;
    WebLabel27.Caption := 'PLN';
    WebLabel28.SetParentComponent(Self);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 495;
    WebLabel28.Top := 290;
    WebLabel28.Width := 18;
    WebLabel28.Height := 13;
    WebLabel28.Caption := 'PLN';
    WebLabel29.SetParentComponent(Self);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 495;
    WebLabel29.Top := 330;
    WebLabel29.Width := 18;
    WebLabel29.Height := 13;
    WebLabel29.Caption := 'PLN';
    WebLabel30.SetParentComponent(Self);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 429;
    WebLabel30.Top := 350;
    WebLabel30.Width := 64;
    WebLabel30.Height := 13;
    WebLabel30.Caption := 'Koszty razem';
    WebLabel31.SetParentComponent(Self);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 495;
    WebLabel31.Top := 372;
    WebLabel31.Width := 18;
    WebLabel31.Height := 13;
    WebLabel31.Caption := 'PLN';
    WebLabel32.SetParentComponent(Self);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 332;
    WebLabel32.Top := 395;
    WebLabel32.Width := 75;
    WebLabel32.Height := 13;
    WebLabel32.Caption := 'Okres zwrotu';
    WebLabel32.Font.Charset := DEFAULT_CHARSET;
    WebLabel32.Font.Color := clBlue;
    WebLabel32.Font.Height := -11;
    WebLabel32.Font.Name := 'Tahoma';
    WebLabel32.Font.Style := [fsBold];
    WebLabel32.ParentFont := False;
    WebLabel33.SetParentComponent(Self);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 541;
    WebLabel33.Top := 350;
    WebLabel33.Width := 48;
    WebLabel33.Height := 13;
    WebLabel33.Caption := 'Koszt VAT';
    WebLabel34.SetParentComponent(Self);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 600;
    WebLabel34.Top := 372;
    WebLabel34.Width := 18;
    WebLabel34.Height := 13;
    WebLabel34.Caption := 'PLN';
    WebLabel35.SetParentComponent(Self);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 429;
    WebLabel35.Top := 394;
    WebLabel35.Width := 116;
    WebLabel35.Height := 13;
    WebLabel35.Caption := 'Koszt razem /z VAT/';
    WebLabel35.Font.Charset := DEFAULT_CHARSET;
    WebLabel35.Font.Color := clBlue;
    WebLabel35.Font.Height := -11;
    WebLabel35.Font.Name := 'Tahoma';
    WebLabel35.Font.Style := [fsBold];
    WebLabel35.ParentFont := False;
    WebLabel36.SetParentComponent(Self);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 495;
    WebLabel36.Top := 414;
    WebLabel36.Width := 18;
    WebLabel36.Height := 13;
    WebLabel36.Caption := 'PLN';
    WebLabel37.SetParentComponent(Self);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 391;
    WebLabel37.Top := 414;
    WebLabel37.Width := 12;
    WebLabel37.Height := 13;
    WebLabel37.Caption := 'lat';
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 8;
    WebImageControl1.Top := 229;
    WebImageControl1.Width := 307;
    WebImageControl1.Height := 189;
    WebImageControl1.ChildOrder := 58;
    WebLabel38.SetParentComponent(Self);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 539;
    WebLabel38.Top := 99;
    WebLabel38.Width := 67;
    WebLabel38.Height := 13;
    WebLabel38.Caption := '(sugerowana)';
    WebLabel39.SetParentComponent(Self);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 8;
    WebLabel39.Top := 428;
    WebLabel39.Width := 211;
    WebLabel39.Height := 13;
    WebLabel39.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel39.Color := clYellow;
    WebLabel39.Transparent := False;
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 539;
    WebEdit1.Top := 116;
    WebEdit1.Width := 49;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 1;
    WebEdit1.Color := 16775408;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '0';
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 8;
    WebEdit2.Top := 118;
    WebEdit2.Width := 77;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 2;
    WebEdit2.Color := 16775408;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '-';
    WebEdit3.SetParentComponent(Self);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 8;
    WebEdit3.Top := 160;
    WebEdit3.Width := 237;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 3;
    WebEdit3.Color := 16775408;
    WebEdit3.Enabled := False;
    WebEdit3.Text := '-';
    WebEdit4.SetParentComponent(Self);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 8;
    WebEdit4.Top := 204;
    WebEdit4.Width := 188;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 4;
    WebEdit4.Color := 16775408;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '-';
    WebEdit5.SetParentComponent(Self);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 97;
    WebEdit5.Top := 118;
    WebEdit5.Width := 105;
    WebEdit5.Height := 19;
    WebEdit5.ChildOrder := 9;
    WebEdit5.Color := 16775408;
    WebEdit5.Enabled := False;
    WebEdit5.Text := '-';
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 212;
    WebEdit6.Top := 118;
    WebEdit6.Width := 94;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 11;
    WebEdit6.Color := 16775408;
    WebEdit6.Enabled := False;
    WebEdit6.Text := '-';
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 317;
    WebEdit7.Top := 118;
    WebEdit7.Width := 96;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 13;
    WebEdit7.Color := 16775408;
    WebEdit7.Enabled := False;
    WebEdit7.Text := '-';
    WebEdit8.SetParentComponent(Self);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 256;
    WebEdit8.Top := 160;
    WebEdit8.Width := 46;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 16;
    WebEdit8.Color := 16775408;
    WebEdit8.Enabled := False;
    WebEdit8.Text := '0';
    WebEdit9.SetParentComponent(Self);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 208;
    WebEdit9.Top := 204;
    WebEdit9.Width := 49;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 17;
    WebEdit9.Color := 16775408;
    WebEdit9.Enabled := False;
    WebEdit9.Text := '0';
    WebEdit10.SetParentComponent(Self);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 339;
    WebEdit10.Top := 160;
    WebEdit10.Width := 49;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 22;
    WebEdit10.Color := 16775408;
    WebEdit10.Enabled := False;
    WebEdit10.Text := '0';
    WebEdit11.SetParentComponent(Self);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 295;
    WebEdit11.Top := 204;
    WebEdit11.Width := 49;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 23;
    WebEdit11.Color := 16775408;
    WebEdit11.Enabled := False;
    WebEdit11.Text := '0';
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 429;
    WebEdit12.Top := 116;
    WebEdit12.Width := 58;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 28;
    WebEdit12.Color := clInfoBk;
    WebEdit12.Enabled := False;
    WebEdit12.Text := '0';
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 429;
    WebEdit13.Top := 159;
    WebEdit13.Width := 59;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 31;
    WebEdit13.Color := clInfoBk;
    WebEdit13.Enabled := False;
    WebEdit13.Text := '0';
    WebEdit14.SetParentComponent(Self);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 429;
    WebEdit14.Top := 201;
    WebEdit14.Width := 59;
    WebEdit14.Height := 19;
    WebEdit14.ChildOrder := 32;
    WebEdit14.Color := clInfoBk;
    WebEdit14.Enabled := False;
    WebEdit14.Text := '0';
    WebEdit15.SetParentComponent(Self);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 429;
    WebEdit15.Top := 245;
    WebEdit15.Width := 59;
    WebEdit15.Height := 19;
    WebEdit15.ChildOrder := 33;
    WebEdit15.Color := clInfoBk;
    WebEdit15.Enabled := False;
    WebEdit15.Text := '0';
    WebEdit16.SetParentComponent(Self);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 429;
    WebEdit16.Top := 287;
    WebEdit16.Width := 59;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 34;
    WebEdit16.Color := clInfoBk;
    WebEdit16.Enabled := False;
    WebEdit16.Text := '0';
    WebEdit17.SetParentComponent(Self);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 429;
    WebEdit17.Top := 327;
    WebEdit17.Width := 59;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 35;
    WebEdit17.Color := clInfoBk;
    WebEdit17.Enabled := False;
    WebEdit17.Text := '0';
    WebEdit18.SetParentComponent(Self);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 429;
    WebEdit18.Top := 369;
    WebEdit18.Width := 59;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 46;
    WebEdit18.Color := 13959039;
    WebEdit18.Enabled := False;
    WebEdit18.Text := '0';
    WebEdit19.SetParentComponent(Self);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 330;
    WebEdit19.Top := 411;
    WebEdit19.Width := 53;
    WebEdit19.Height := 19;
    WebEdit19.ChildOrder := 49;
    WebEdit19.Color := 14481663;
    WebEdit19.Text := '0';
    WebEdit20.SetParentComponent(Self);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 539;
    WebEdit20.Top := 369;
    WebEdit20.Width := 53;
    WebEdit20.Height := 19;
    WebEdit20.ChildOrder := 51;
    WebEdit20.Color := 14480885;
    WebEdit20.Text := '0';
    WebEdit21.SetParentComponent(Self);
    WebEdit21.Name := 'WebEdit21';
    WebEdit21.Left := 429;
    WebEdit21.Top := 411;
    WebEdit21.Width := 59;
    WebEdit21.Height := 19;
    WebEdit21.ChildOrder := 54;
    WebEdit21.Color := 13959039;
    WebEdit21.Text := '0';
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
    WebEdit21.AfterLoadDFMValues;
  end;
end;

end.
